module.exports = __webpack_public_path__ + "static/media/error-deactivate.ec6ec968.svg";